<div class="container" fxLayout="column" fxLayoutGap="20px">
  <div fxLayout="column" fxLayoutAlign="center center" class="icon-container">
    <mat-icon>phone</mat-icon>
  </div>
  <h2 class="fs-18px mb-10">{{ 'keywords.enter_phone_number' | translate }}:</h2>
  <app-input
    [formControl]="contactNumber"
    label="keywords.contactNo"
    controlType="mask"
    [showAsterisk]="false"
    [controlRegex]="paterns.numbers"
    [prefix]="phoneMaskPrefix"
    [mask]="phoneMask" />
  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between center">
    <button class="medium-button-white" fxFlex="50" mat-button (click)="closeDialog()">
      {{ 'keywords.cancel' | translate }}
    </button>
    <button class="medium-button-blue" fxFlex="50" mat-button (click)="proceed()" [disabled]="contactNumber.invalid">
      Ok
    </button>
  </div>
</div>
